import { Component, inject, Input, OnInit } from '@angular/core';
import { Note, ProductsWithPriceAndNoteLabels, ProductWithPriceAndAdditionalInfo } from '../../models/types';
import { getGeneralFeesLabels } from '../../utils/table-utils';
import { Company, CompanyEnum } from '../../models/company.model';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { PriceAndNoteTableComponent } from '../price-and-note-table/price-and-note-table.component';
import { PriceListGeneralFeeProduct } from '../../models/pricelist-general-fee.model';
import { Currency } from '../../models/currency.model';
import { NgIf } from '@angular/common';
import { NotesComponent } from '../notes/notes.component';
import { SubjectEnum } from '../../utils/notes.utils';
import { PriceListNote } from '../../models/priceslist-note.model';
import { NotesService } from '../../services/notes.service';

@Component({
  standalone: true,
  imports: [TableHeaderComponent, PriceAndNoteTableComponent, NgIf, NotesComponent],
  selector: 'lx-price-lists-portal-general-fee-table',
  templateUrl: './general-fee-table.component.html',
  styleUrls: ['./general-fee-table.component.scss'],
})
export class GeneralFeeTableComponent implements OnInit {
  @Input() currency: Currency | undefined;
  @Input() company: Company = CompanyEnum.KIL;
  @Input() generalFees: PriceListGeneralFeeProduct[] | undefined;
  @Input() generalFeesNotes: PriceListNote[] | undefined;

  notes: Note[] | undefined;
  notationMarks: Record<string, string> | undefined;
  dataSource: ProductWithPriceAndAdditionalInfo[] = [];
  columnLabels: ProductsWithPriceAndNoteLabels | undefined;

  private readonly notesService = inject(NotesService);

  ngOnInit(): void {
    this.columnLabels = getGeneralFeesLabels();

    this.dataSource = this.generalFees?.map(({ name, additionalInfo, price }) => ({
      name,
      price: price?.price,
      additionalInfo,
    }));

    const generalFees = this.notesService.getNotes(this.generalFeesNotes, SubjectEnum.GENERAL_FEES);
    if (generalFees) {
      [this.notes, this.notationMarks] = generalFees;
    }
  }
}
